import { Auth } from "aws-amplify";

export const getCurrentCredentials = async () => {
  const currentUserCredentials = await Auth.currentAuthenticatedUser();
  const credentials = await Auth.currentCredentials();
  const credentialsObj = {};
  credentialsObj.sessionToken = credentials.sessionToken;
  credentialsObj.secretAccessKey = credentials.data.Credentials.SecretKey;
  credentialsObj.accessKeyId = credentials.accessKeyId;
  return credentialsObj;
};
